import { styled } from '@gogovan/entier-web-core/ext/mui/styles';
import { FreeCreatableAutocomplete } from '@gogovan/entier-web-core/form-components';
import { Chip } from '@gogovan/entier-web-core/ext/mui/Chip';
import { Paper } from '@gogovan/entier-web-core/ext/mui/Paper';
import { Box } from '@gogovan/entier-web-core/ext/mui/Box';

const SearchRow = styled('div')`
  display: flex;
  //align-items: center;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 48px;
  margin-bottom: 16px;
  position: relative;

  ${(props) => props.theme.breakpoints.down('sm')} {
    flex-direction: column;
    padding: 0 24px;
  }
`;

const SearchAutocomplete = styled(FreeCreatableAutocomplete)`
  width: 100%;

  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 100%;
  }
`;

const ButtonContainer = styled('div')`
  margin: 8px 0 0 10px;
  display: flex;
  width: 130px;
  white-space: nowrap;

  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 100%;
    flex-direction: column;
    margin: 8px 0 0;
    min-width: unset;
  }
`;

const SearchHistoryContainer = styled(Paper)`
  width: ${(props) => (props.width ? `${props.width - 96 - 122}px` : '0px')};
  display: flex;
  flex-direction: column;

  ${(props) => props.theme.breakpoints.down('sm')} {
    width: ${(props) => (props.width ? `${props.width - 48}px` : '0px')};
  }
`;

const SearchHistoryContent = styled('div')`
  padding: 10px 10px 5px;
`;

const TrackingHistoryChip = styled(Chip)`
  width: min-content;
  margin: 4px;
`;

const SearchHistoryBox = styled(Box)`
  position: absolute;
  top: ${(props) => props.positionTop - (props.hasError ? 20 : 0)}px;
  z-index: 9999;

  ${(props) => props.theme.breakpoints.down('sm')} {
    top: ${(props) => props.positionTop - 45 - (props.hasError ? 20 : 0)}px;
  }
`;

export {
  SearchRow,
  SearchAutocomplete,
  ButtonContainer,
  SearchHistoryContainer,
  TrackingHistoryChip,
  SearchHistoryContent,
  SearchHistoryBox,
};
